import { FC, useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import {
  Box,
  Typography,
  IconButton,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
} from '@mui/material';
import DeleteDialog from 'components/DeleteDialog';
import DeleteIcon from '@mui/icons-material/Delete';
import { deleteGroupFormatsRulesItem } from 'api/tournamentformatgroups';

/**
 * Свойства компонента.
 */
type Props = {
  /**
   * Детали группы.
   */
  data: any;

  /**
   * ID метки
   */
  markId: string;
};

/**
 * Таблица содержащая информацию о группах и значения форматов
 */
const TournamentFormatGroupsDetails: FC<Props> = ({ data, markId }) => {
  const [open, setOpen] = useState(false);
  const [item, setItem] = useState<string>();

  const queryClient = useQueryClient();  
  const { mutate, isLoading } = useMutation(deleteGroupFormatsRulesItem, {
      onSuccess: () => {
          queryClient.invalidateQueries('format-group-list-data');
      },
    });

  function deliteItem() {
    mutate({ group_id: markId, rule_id: item });
    setOpen(false);
  }

  function openDialog (id: string) {
    setItem(id);
    setOpen(true);
  }
  return (
      <Box>
          <Box>
              {data.length === 0 && <Box className='flex items-center justify-center h-32'><Typography>Значения отсутствуют</Typography></Box>}
              {data.length > 0 && (
                <Table sx={{ minWidth: 650 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell width={300}>Формат</TableCell>
                      <TableCell>Включенные тэги</TableCell>
                      <TableCell>Исключенные тэги</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data.map(item => (
                      <TableRow key={item.id}>
                        <TableCell>
                          <Box className='flex flex-row items-center'>
                            <Box>
                              <IconButton onClick={() => openDialog(item.id)} disabled={isLoading} size="small">
                                <DeleteIcon />
                              </IconButton>
                              <DeleteDialog close={() => setOpen(false)} open={open} handleAgreeAction={() => deliteItem()}/>
                            </Box>
                            <Typography variant='body1'>{item.tournament_format.name}</Typography>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Box className='flex flex-row gap-2'>
                            {item.include_tags.map((data, index) => {
                              return (
                                  <Chip label={data} key={index} />
                              );
                            })}
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Box className='flex flex-row gap-2'>
                            {item.exclude_tags.map((data, index) => {
                              return (
                                  <Chip label={data} key={index} />
                              );
                            })}
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}
          </Box>
      </Box>
  )
}

export default TournamentFormatGroupsDetails;
